
import Inputmask from 'inputmask'

/*
 * Input mask
 */
export function initInputMask(elem = document) {
    let inputMaskTriggerList = [].slice.call(elem.querySelectorAll('[data-toggle="input-mask"]'));
    inputMaskTriggerList.map(function (inputMaskTriggerEl) {
        const maskFormat = inputMaskTriggerEl.getAttribute('data-mask-format').toString().replaceAll('0', '9');
        inputMaskTriggerEl.setAttribute("data-mask-format", maskFormat);
        const im = new Inputmask(maskFormat);
        im.mask(inputMaskTriggerEl);
    });
}

